module.exports = __webpack_public_path__ + "static/media/use-icon.34df80f0.png";